import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
@Component({
  selector: 'app-add-offer',
  templateUrl: './add-offer.component.html',
  styleUrls: ['./add-offer.component.scss']
})
export class AddOfferComponent implements OnInit {

  formGroup;
  postData: any = {};
  submitted = false;
  fileToUpload: any;
  // formGroup;
  products: any = [];
  categories: any = [];
  selectedProducts: any = [];
  finalProductList: any = [];
  selectAll: Boolean = true;
  productView: Boolean = true;
  categoryView: Boolean = true;
  selectType: Boolean = false;
  offerTypes = [
    {
      id: 1,
      name: "Product"
    },
    {
      id: 2,
      name: "Category"
    },
    {
      id: 3,
      name: "Sub Category"
    },
    {
      id: 4,
      name: "General"
    }
  ];

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastClientService,
    private ngWizardService: NgWizardService,
    private modalService: NgbModal,
  ) { }


  ngOnInit() {

    this.formGroup = this.fb.group({
      program_id: 1,
      offer_name: new FormControl('', [Validators.required]),
      offer_description: new FormControl('', [Validators.required]),
      offer_start_date: new FormControl('', [Validators.required]),
      offer_end_date: new FormControl('', [Validators.required]),
      offer_type: new FormControl('', [Validators.required]),
      discount_type: new FormControl('', [Validators.required]),
      discount_value: new FormControl('', [Validators.required]),
      offer_image: new FormControl(''),
      category_id: new FormControl(''),
    });

  }

  //stepper
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };


  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }
  //stepper end

  get f() {
    return this.formGroup.controls
  }


  handleFileInput(listOfFiles) {
    let file = listOfFiles[0];
    let fileSize = file.size;

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      this.fileToUpload = reader.result;
    }
  }

  back() {
    this.router.navigateByUrl('/hubAdmin/list-category')
  }

  offerTypeSelected(type) {
    //if type is product
    if (type == 1) {
      this.getAllProducts();
      this.productView = false;
      this.selectType = true;
      this.categoryView = true;
    } else if (type == 2) {
      this.getAllCategories();
      this.categoryView = false;
      this.productView = true;
      this.selectType = true;
    }
  }

  getAllCategories() {
    this.apiService.get(this.apiConfig.getProductCategories)
      .subscribe((res: any) => {
        this.categories = res.data.ecommerce_categories
      }, err => {
        this.toast.Error('Error retreving categories')
      })
  }

  getAllProducts() {
    this.apiService.get(this.apiConfig.getProductsList)
      .subscribe((res: any) => {
        this.products = res.data.product_details
        this.products.forEach(prod => {
          prod.isSelected = true;
        });
        this.selectedProducts = this.products;
      }, err => {
        this.toast.Error('Error retreving products');
      })
  }

  //display products in a modal if type is products
  showProductsModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
  }

  //handle product checkbox
  checkboxAction(i) {
    this.selectedProducts[i].isSelected = !this.selectedProducts[i].isSelected;
  }

  // select/deselect all
  toggleAll() {
    this.selectAll = !this.selectAll;

    if (this.selectAll == true) {
      this.selectedProducts.forEach(product => {
        product.isSelected = true;
      });
    } else {
      this.selectedProducts.forEach(product => {
        product.isSelected = false;
      });
    }
  }

  getSelectedProducts() {
    this.finalProductList = [];
    this.selectedProducts.forEach(product => {
      if (product.isSelected == true) {
        this.finalProductList.push(product);
      }
    });
  }

  closeProductsModal() {
    this.modalService.dismissAll();
  }


  onSubmitOffer(formData: any) {

    this.submitted = true;

    if (this.formGroup.invalid) {
      return;
    }

    if (formData.offer_type == 1) {
      this.getSelectedProducts();
      let productIds = []
      this.finalProductList.forEach(product => {
        productIds.push(product.product_id);
      });
      formData.product_id = productIds.toString();
    }
    
    formData.offer_image = this.fileToUpload;
    formData.value_start_date = formData.offer_start_date;
    formData.value_end_date = formData.offer_end_date;

    this.apiService.post(this.apiConfig.createOffer, formData)
      .subscribe((res: any) => {
        this.toast.Success('Offer added successfully')
        this.router.navigateByUrl('/hubAdmin/offer-list')
      }, err => {
        this.toast.Error('Error adding category');
      })

  }

  imageChange(img) {

    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function () {
      //self.AddOffer.controls['offer_image'].setValue(reader.result);
      self.formGroup.value.offer_image = reader.result;
      self.fileToUpload = reader.result;
    }
    reader.readAsDataURL(file);

  }

}

